<template>
  <div class="lesson-in-analysis-wrapper">
    <a-tabs @change="handleChangeTab" :active-key="activeKey">
      <a-tab-pane key="1" tab="日积月累" />
      <a-tab-pane key="2" tab="融会贯通" />
    </a-tabs>
    <template v-if="loading">
      <div class="loading">
        加载中...
      </div>
    </template>
    <template v-else>
      <div class="content-wrapper" v-if="videoList.length !== 0 || masteryAnalysisVideo || daysMonthsMultiplyVideo">
        <div class="daysMultiply-wrapper" v-show="activeKey === '1'">
          <template v-if="daysMonthsMultiplyVideo || videoList.length">
            <div class="exist-video" v-if="daysMonthsMultiplyVideo">
              <div class="days-multiply-video" id="daysMultiplyVideo" ref="daysMultiplyVideo" />
            </div>
            <template v-else>
              <ul class="resource-list" v-if="videoList.length">
                <li v-for="(video, index) in videoList" :key="index" :class="{ active: index === curIndex }">
                  <Topic :render="render" :topic="video" :index="index" @topic-select="handleTopicSelect" />
                </li>
              </ul>
              <div class="cur-topic-source" ref="curTopicsource" />
            </template>
          </template>
          <div v-else class="empty-list">
            暂无内容
          </div>
        </div>
        <div class="integrate-video" v-show="activeKey === '2'">
          <div v-if="masteryAnalysisVideo" class="integrate-player">
            <div id="integratePlayer" ref="integratePlayer" />
            <div ref="integrateWrap" />
          </div>
          <div v-else>
            暂无资源
          </div>
        </div>
      </div>
      <div class="empty-wrapper" v-else>
        <span>暂无内容</span>
      </div>
    </template>
  </div>
</template>
<script>
import { findTeacherExplainVedio } from '../../hooks'
import Topic from './topic.vue'
import videoService from '@/service/video/index'
import VideoScale from '@/components/PolyvPlayer/VideoScale.vue'
import { createApp } from 'vue-demi'
const tkSdk = new TkSdk()
const render = tkSdk.renderInstance({
  // tkSDK latex2svg 配置 topicType优先级高于 data的type
  // latex2svg: {
  //   fontsize, type, topicType
  // },
  polyvSetting: {
    playsafe: (vid, next) => {
      videoService.getPolyvToken({ vid }).then(data => {
        next(data.token)
      })
    }
  },
  aliyunSetting: {
    async playsafe(vid) {
      return await videoService.getAliToken({ vid })
    }
  }
})

const AliyunDefaultSetting = {
  vid: '',
  playauth: '',
  height: '100%',
  width: '100%',
  useH5Prism: true,
  cover: null,
  autoplay: false,
  encryptType: 1,
  skinLayoutIgnore: ['bigPlayButton']
}

export default {
  components: {
    Topic
  },
  props: {
    classTypeId: {
      type: String
    },
    lessonId: {
      type: String
    }
  },
  data() {
    return {
      activeKey: '1',
      videoList: [],
      masteryAnalysisVideo: null, // 融汇贯通
      daysMonthsMultiplyVideo: null, // 日积月累
      curTopicsource: null,
      curIndex: 0,
      loading: true,
      render
    }
  },
  mounted() {
    this.findTeacherExplainVedioData()
  },
  methods: {
    handleChangeTab(index) {
      if (this.activeKey == index) return
      try {
        if (this.activeKey === '1' && this.daysMonthsPlayer) {
          this.daysMonthsPlayer.pause()
        }
        if (this.activeKey === '2' && this.masteryAnalysisPlayer) {
          this.masteryAnalysisPlayer.pause()
        }
      } catch (error) {}

      this.activeKey = index
      if (+index === 2 && this.masteryAnalysisVideo && !this.masteryAnalysisPlayer) {
        this.$nextTick(() => {
          this.handleMasteryAnalysisVideoRender()
        })
      }
    },
    findTeacherExplainVedioData() {
      findTeacherExplainVedio({ classTypeId: this.classTypeId, lessonId: this.lessonId })
        .then(res => {
          this.videoList = res.aiAccompanyQuestionList || []
          this.masteryAnalysisVideo = res.masteryAnalysisVideo
          this.daysMonthsMultiplyVideo = res.daysMonthsMultiplyVideo
          this.loading = false
          if (this.daysMonthsMultiplyVideo) {
            this.$nextTick(() => {
              this.handleDaysMonthsMultiplyVideoRender()
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    async handleMasteryAnalysisVideoRender() {
      const root = this.$refs.integratePlayer.parentElement
      const isAli = this.masteryAnalysisVideo?.aliVid
      // 初始化播放器
      if (isAli) {
        // 阿里云非分片视频，直接使用sdk播放器
        Aliplayer.__unable2Anti9Debugger13Key = 'error'
        const playauth = (await videoService.getAliToken({ vid: this.masteryAnalysisVideo?.aliVid }))?.token
        const videoPlayer = new window.Aliplayer({
          ...AliyunDefaultSetting,
          playauth,
          vid: this.masteryAnalysisVideo?.aliVid,
          id: 'integratePlayer'
        })
        this.masteryAnalysisPlayer = videoPlayer
      } else {
        // 保利威使用封装的播放器
        const videoPlayer = createApp(VideoScale, {
          width: root.clientWidth,
          height: root.clientHeight
        }).mount(this.$refs.integratePlayer)
        videoPlayer.playerInit({ scriptJson: [], videoUrl: this.masteryAnalysisVideo.path }).then(() => {
          videoPlayer.voChangeTags()
        })
        this.masteryAnalysisPlayer = videoPlayer
      }
    },
    async handleDaysMonthsMultiplyVideoRender() {
      const root = this.$refs.daysMultiplyVideo
      const isAli = this.daysMonthsMultiplyVideo?.aliVid
      // 初始化播放器
      if (isAli) {
        // 阿里云非分片视频，直接使用sdk播放器
        Aliplayer.__unable2Anti9Debugger13Key = 'error'
        const playauth = (await videoService.getAliToken({ vid: this.daysMonthsMultiplyVideo?.aliVid }))?.token
        const videoPlayer = new window.Aliplayer({
          ...AliyunDefaultSetting,
          playauth,
          vid: this.daysMonthsMultiplyVideo?.aliVid,
          id: 'daysMultiplyVideo'
        })
        this.daysMonthsPlayer = videoPlayer
      } else {
        // 保利威使用封装的播放器
        const videoPlayer = createApp(VideoScale, {
          width: root.clientWidth,
          height: root.clientHeight
        }).mount(this.$refs.daysMultiplyVideo)
        videoPlayer.playerInit({ scriptJson: [], videoUrl: this.daysMonthsMultiplyVideo.path }).then(() => {
          videoPlayer.voChangeTags()
        })
        this.daysMonthsPlayer = videoPlayer
      }
    },
    handleTopicSelect(topic, index) {
      if (this.curIndex === topic) return
      this.curTopicsource = topic
      this.curIndex = index || 0
      if (this.$refs.curTopicsource) {
        this.$refs.curTopicsource.innerHTML = ''
      }
      console.log('topic =====', topic)

      const result = render(topic)
      const resultHtml = result.TPL.getStructure()
      const { polyv, childs, jiexi, answer } = resultHtml
      const div = document.createElement('div')
      if (!polyv && !childs && !jiexi && !answer) {
        div.innerText = '无数据'
        div.style = 'display: flex; align-items: center;justify-content:center;height: 100%'
      }

      if (childs) {
        childs.forEach((child, index) => {
          // const h6 = document.createElement('h6')
          // h6.innerHTML = index + 1 + '.'
          // div.appendChild(h6)
          const { polyv: childPolyv, jiexi: childJiexi, answer: childAnswer, tiGan } = child
          const ul = document.createElement('ul')
          ul.className = 'curTopcChilds'
          div.appendChild(ul)
          const li = document.createElement('li')
          li.appendChild(tiGan)

          tiGan && tiGan.querySelector('.axx_piece')?.remove()

          if (childAnswer) {
            li.appendChild(childAnswer)
          }
          if (childJiexi) {
            li.appendChild(childJiexi)
          }
          if (childPolyv) {
            li.appendChild(childPolyv)
          }

          ul.appendChild(li)
        })
      }
      if (answer) {
        div.appendChild(answer)
      }

      if (jiexi) {
        div.appendChild(jiexi)
      }

      if (polyv) {
        div.appendChild(polyv)
      }

      this.$refs.curTopicsource.innerHTML = div.outerHTML
    }
  }
}
</script>
<style scoped lang="less">
.loading {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
:deep(.ant-tabs-nav) {
  font-size: 16px !important;
}
.lesson-in-analysis-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  .ant-tabs-line {
    padding-left: 0;
    box-shadow: 0px 1px 0px #ebedf0;
  }
  :deep(.ant-tabs-ink-bar) {
    position: absolute;
  }
  .content-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex: 1;
    margin-right: 10px;
    overflow: hidden;
  }
}
.days-multiply-video {
  flex-shrink: 0;
  height: 100%;
  height: 100%;
}
.daysMultiply-wrapper {
  flex-shrink: 0;
  height: 100%;
  overflow: hidden;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .exist-video {
    width: 100%;
    height: 100%;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}

.integrate-video {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.resource-list {
  border-right: 1px solid #ebedf0;
  overflow-y: auto;
  height: 100%;
  width: 700px;
  margin: 0;
  &::-webkit-scrollbar {
    display: none;
  }
  li {
    border-bottom: 1px solid #f1f5f9;
    padding-top: 10px;
    &:last-child {
      border-bottom: 0;
    }
    &.active {
      background-color: #f5f7f9;
    }
  }
  :deep(img) {
    max-width: 100% !important;
  }
  &.empty-list {
    align-items: center;
    justify-content: center;
    display: flex;
  }
}
.cur-topic-source {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 10px;
  :deep(img) {
    max-width: 100% !important;
    width: 100% !important;
  }
  :deep(.topic-render-container) {
    width: 100%;
    .topic-render-container {
      padding-left: 0;
      padding-right: 0;
    }
  }
  :deep(.tr-video-jx) {
    width: 100%;
  }
  :deep(.curTopcChilds) {
    margin-bottom: 15px;
    border-bottom: 1px solid #f1f5f9;
  }
  :deep(.axx_piece) {
    overflow-x: auto !important;
  }
}
.video-source {
  position: relative;
  align-items: flex-start;
  justify-content: flex-start;
  display: flex;
  flex: 1;
  overflow-y: auto;
  :deep(img) {
    max-width: 100% !important;
    width: 100% !important;
  }
  :deep(.topic-render-container) {
    width: 100%;
  }
  :deep(.tr-video-jx) {
    width: 100%;
  }
}

.integrate-player {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.empty-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
:deep(.prism-cover) {
  display: none !important;
}
</style>
